import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/primary-arrow-left.png'
import _imports_1 from '@/assets/icon/close.png'


const _withScopeId = n => (_pushScopeId("data-v-4f1942f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = { class: "box-info" }
const _hoisted_4 = { class: "box-title" }
const _hoisted_5 = { class: "program-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "people-collection"
}
const _hoisted_8 = {
  key: 1,
  class: "time"
}
const _hoisted_9 = {
  key: 2,
  class: "collection-challenge"
}
const _hoisted_10 = { class: "box-footer" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "box-footer"
}
const _hoisted_13 = { class: "box-footer" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

import { USER_REQUEST_STATE_MAP, PEOPLE_COLLECTION_MAP, ColorVariants } from '@/constants';
  import { useI18n } from 'vue-i18n';
  import { IUserRequest } from '@/types/user-request';
  import { request, requestCollection, confirm } from '@/utils';
  import _ from 'lodash';
  import { useToast } from 'bootstrap-vue-3';
  import { computed } from 'vue';
  import dayjs from 'dayjs';

  interface IProps {
    modelValue: IUserRequest,
    role: string | undefined
  }

  interface IEmits {
    (event: 'update:model-value', modelValue: IUserRequest): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    role: null
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:model-value', modelValue: IUserRequest): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue: IUserRequest,
    role: string | undefined
  }

  const { t, locale } = useI18n();
  const toast = useToast();

  
  

  // 回收类型，线上、线下
  const targetShowTypes = computed(() => {
    return  props.modelValue.target?.program_detail_info_attributes?.show_types || [];
  });
  // 是否包含线上
  const hasOnlineShowType = computed(() => {
    return  targetShowTypes.value.includes('online');
  });
  // 是否包含线下
  const hasOfflineShowType = computed(() => {
    return  targetShowTypes.value.includes('offline');
  });

  const collectionHistoryJump = computed(() => {
    // 韩国这几个OnGoingProgram要特殊处理
    // https://www.terracycle-kr.com/programs/gpzw_collectionD
    // https://www.terracycle-kr.com/programs/gpzw_collectionC
    // https://www.terracycle-kr.com/programs/gpzw_collectionB
    // https://www.terracycle-kr.com/programs/gpzw_collectionA
    const targetId = props.modelValue?.target?.id;
    if (locale.value === 'ko' && [3, 4, 5, 6].includes(targetId)) {
      return ['approved', 'closed'].includes(props.modelValue.state);
    }
    // B2始终可以点击
    if (props.role === 'store_sub') {
      return true;
    }
    // 通过了审核或者关闭的才可以走后续判断
    if (!['approved', 'closed'].includes(props.modelValue.state)) {
      return false;
    }
    // C 有线上提交记录保持点击，或者当前tab有线上可以点击
    return props.modelValue.has_online_collection_requests || hasOnlineShowType.value;
  });

  const ocCollectionHistoryJump = computed(() => {
    // B2始终不可以点击
    if (props.role === 'store_sub') {
      return false;
    }
    // 通过了审核或者关闭的才可以走后续判断
    if (!['approved', 'closed'].includes(props.modelValue.state)) {
      return false;
    }
    // C 有提交记录保持点击
    if (props.modelValue.has_offline_collection_requests) {
      return true;
    }
    // C 有线下提交记录保持点击、或者当前tab有线下可以点击
    return props.modelValue.has_offline_collection_requests || hasOfflineShowType.value;
  });

  const showRequestCollection = computed(() => {
    const { state, target } = props.modelValue;
    const isEnd = target.ended_at ? dayjs().isBefore(dayjs(target.ended_at)) : false;
    // B2在个人中心的program参加列表，一直显示线上回收按钮。除非取消参加
    if (props.role === 'store_sub') {
      return state !== 'closed';
    }
    // admin配置了隐藏按钮，普通用户走这个判断，同详情
    if (target.hide_collection_btn) {
      // 如果配置了隐藏按钮，普通用户要返回false(不显示)
      return !(props.role !== 'store_sub' || !target.is_pdo_of_program);
    }
    // 线下回收不显示回收按钮(PDO例外)
    return (hasOnlineShowType.value || target.is_pdo_of_program) && (target.type === 'OnGoingProgram' && (!isEnd) && state === 'approved');
  });

  const showCloseButton = computed(() => {
    return props.modelValue.state === 'approved';
  });

  async function handleRequest() {
    const program = props.modelValue.target;
    try {
      const result = await requestCollection(program);
      if (result) {
        if (result.status === 'success') {
          toast.show({ title: t('on_going_program_apply_success_content') }, { variant: ColorVariants.success });
        }
        if (result.status === 'wait_list') {
          toast.show({ title: t('on_going_program_join_waiting_list_success_content') }, { variant: ColorVariants.info });
        }
      }
    } catch (e) {
      const errorMsg = _.get(e, 'message');
      toast.show({ title: errorMsg });
      throw e;
    }
  }

  async function handleDelete() {
    await confirm(t('close_confirm_text'), { class: `modal-record-item-delete-${locale.value}` });
    await request.put(`user_requests/${props.modelValue.id}/close_participation_request`);
    emits('update:model-value', {
      ...props.modelValue,
      state: 'closed'
    });
  }

  function handleClickArrow(e: Event, jump: boolean) {
    if (!jump) {
      e.preventDefault();
    }
  }


return (_ctx: any,_cache: any) => {
  const _component_AppCustomLink = _resolveComponent("AppCustomLink")!
  const _component_AppTimeFormat = _resolveComponent("AppTimeFormat")!
  const _component_AppArrowIcon = _resolveComponent("AppArrowIcon")!
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-user-request", [`lang-${_unref(locale)}`]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["state", [__props.modelValue.state]])
    }, _toDisplayString(_unref(USER_REQUEST_STATE_MAP)[__props.modelValue.state]), 3),
    _createElementVNode("img", {
      class: "cover",
      src: __props.modelValue.target.image?.url
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.modelValue.target.name), 1),
          _createVNode(_component_AppCustomLink, {
            to: { name: 'programs.show', params: { slug: __props.modelValue.target.slug } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('program_detail')) + " ", 1),
              _hoisted_6
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        (__props.modelValue.people_collection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(PEOPLE_COLLECTION_MAP)[__props.modelValue.people_collection]), 1))
          : _createCommentVNode("", true),
        (_unref(locale) !== 'ja')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(_unref(t)('created_at')) + " : ", 1),
              _createVNode(_component_AppTimeFormat, {
                time: __props.modelValue.created_at,
                format: "YYYY-MM-DD"
              }, null, 8, ["time"])
            ]))
          : _createCommentVNode("", true),
        (__props.modelValue.collection_challenge)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(t)('collection_challenge')) + " : " + _toDisplayString(__props.modelValue.collection_challenge), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_AppCustomLink, {
          to: { name: 'mine.programParticipationDetail', params: { id: __props.modelValue.id } }
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: "link-history",
              disabled: !_unref(collectionHistoryJump)
            }, [
              _createTextVNode(_toDisplayString(_unref(t)('Collection History')) + " ", 1),
              _createVNode(_component_AppArrowIcon, {
                class: _normalizeClass(["arrow", { disabled: !_unref(collectionHistoryJump) }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClickArrow($event, _unref(collectionHistoryJump))))
              }, null, 8, ["class"])
            ], 8, _hoisted_11)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      (_unref(showRequestCollection))
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_unref(showRequestCollection))
              ? (_openBlock(), _createBlock(_component_AppLoadingButton, {
                  key: 0,
                  class: "button-request",
                  pill: "",
                  variant: _unref(ColorVariants).primary,
                  onClick: handleRequest
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('request_collection')), 1)
                  ]),
                  _: 1
                }, 8, ["variant"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_router_link, {
          to: { name: 'oc_user_requests.detail', params: { id: __props.modelValue.id } }
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: "link-history",
              disabled: !_unref(ocCollectionHistoryJump)
            }, [
              _createTextVNode(_toDisplayString(_unref(t)('offline_collection.oc_collection_history')) + " ", 1),
              _createVNode(_component_AppArrowIcon, {
                class: _normalizeClass(["arrow", { disabled: !_unref(ocCollectionHistoryJump) }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClickArrow($event, _unref(ocCollectionHistoryJump))))
              }, null, 8, ["class"])
            ], 8, _hoisted_14)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    (_unref(showCloseButton))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "button-close",
          onClick: handleDelete
        }, _hoisted_16))
      : _createCommentVNode("", true)
  ], 2))
}
}

})